import React from "react";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";

import app from "../firebase";

import { getStorage } from "firebase/storage";
import { RequestLogObjectType } from "../../types/database";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

const db = getFirestore(app);
const storage = getStorage(app);

export const RequestLog = {
  One: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<RequestLogObjectType | null>(null);

    const runRequest = async (itemId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = doc(db, "requestLogs", itemId);
          const mainSnap = await getDoc(mainRef);

          const itemObj = { id: itemId, ...mainSnap.data() } as RequestLogObjectType;
          setLoading(false);

          if (!mainSnap.exists()) return Rej(new Error("Item não existe."));

          setItem(itemObj);

          Ok(itemObj);
        } catch (error) {
          console.log(...new Dev("Request Error [one]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  LazyList: (definedLimit: number = 5) => {
    const [isLoading, setLoading] = React.useState(false);
    const [hasMore, setHasMore] = React.useState(false);

    const [lastItemRef, setLastItemRef] = React.useState<any>(null);

    const [items, setItems] = React.useState<RequestLogObjectType[]>([]);

    const runRequest = async (topic?: string[], restart?: boolean) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "requestLogs");

          const args = [orderBy("createdAtTimestamp", "desc")] as any[];

          if (lastItemRef && !restart) {
            args.push(startAfter(lastItemRef));
          }

          args.push(limit(definedLimit));

          if (topic) {
            args.unshift(where("resource", "in", topic));
          }

          const queryRef = query(mainRef, ...args);

          const mainSnap = await getDocs(queryRef);

          setLastItemRef(mainSnap.docs[mainSnap.docs.length - 1] || null);

          const listData = [] as RequestLogObjectType[];

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() } as RequestLogObjectType);
          });

          setItems(restart ? [...listData] : [...items, ...listData]);

          if (listData.length < definedLimit) setHasMore(false);
          else setHasMore(true);

          setLoading(false);

          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { items, isLoading, runRequest, hasMore };
  },
};
